"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var PartnersPromoCodeTemplatesListCtl = /** @class */ (function (_super) {
    __extends(PartnersPromoCodeTemplatesListCtl, _super);
    function PartnersPromoCodeTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_promocode_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_id; });
        _this.dk_promocode_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_title; });
        _this.dk_max_promocodes_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_promocodes_count; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_promocode_template_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_type_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    PartnersPromoCodeTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    PartnersPromoCodeTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "partner promo code template with id [" + id + "] not found !";
    };
    PartnersPromoCodeTemplatesListCtl.prototype.LoadData = function (UsrPartnerId, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPartnersPromoCodeTemplatesGet.exec({ usr_partner_id: UsrPartnerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    promocode_template_id: resp.list[i].promocode_template_id,
                    promocode_template_title: resp.list[i].promocode_template_title,
                    max_promocodes_count: resp.list[i].max_promocodes_count,
                    description: resp.list[i].description,
                    promocode_template_type_title: resp.list[i].promocode_template_type_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersPromoCodeTemplatesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPartnerPromoCodeTemplate.exec({
            usr_partner_id: data.usr_partner_id,
            promo_code_template_id: data.promo_code_template_id,
            max_promo_count: data.max_promo_count,
            description: data.description
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: resp.brand_id,
                brand_title: resp.brand_title,
                promocode_template_id: data.promo_code_template_id,
                promocode_template_title: resp.promo_code_template_title,
                max_promocodes_count: data.max_promo_count,
                description: data.description,
                promocode_template_type_title: resp.template_type_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PartnersPromoCodeTemplatesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPProgramPartnerPromoCodeTemplate.exec({
                data: {
                    usr_partner_promo_code_template_id: data.key,
                    max_promocodes_count: data.max_promocodes_count,
                    // promocode_template_id: data.promo_code_template_id,
                    description: data.description
                }
            }, function (resp) {
                _tmp.max_promocodes_count = data.max_promocodes_count;
                _tmp.description = data.description;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PartnersPromoCodeTemplatesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PartnersPromoCodeTemplatesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePProgramPartnerPromoCodeTemplate.exec({
                data: {
                    usr_partner_promocode_template_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PartnersPromoCodeTemplatesListCtl;
}(BaseController_1.BaseController));
exports.PartnersPromoCodeTemplatesListCtl = PartnersPromoCodeTemplatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ctl/PartnersPromoCodeTemplatesListCtl.ts
// module id = 1000
// module chunks = 0